import { render, staticRenderFns } from "./SaveTemplateUpBox.vue?vue&type=template&id=0d840359&"
import script from "./SaveTemplateUpBox.vue?vue&type=script&lang=js&"
export * from "./SaveTemplateUpBox.vue?vue&type=script&lang=js&"
import style0 from "./SaveTemplateUpBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports